<template>
  <div class="main">
      <div class="info">
        <el-row>
            <el-col v-for="(item,index) in alarmsRealtimeData" :key="index" :span="6">
                <!-- <span>{{item.alias}}</span>：{{item.data}} {{item.unitOrDescription}} -->
                <el-row>
                    <el-col class="item" :span="15">{{item.alias?item.alias:item.name}}</el-col>
                    <el-col class="item" :span="9">{{item.data}} {{item.unitOrDescription}}
                        <span class="edit" v-if="is_update_data == 1 && item.readWritePermission == 'rw'" @click="edit(item)">(修改)</span>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
      </div>
      <el-dialog title="修改数值" :visible.sync="dialogEditData" width="30%">
        <el-form :model="form" label-position="right" label-width=".8rem" ref="edit" :rules="editRules">
            <el-form-item label="数值" prop="value">
                <el-input type="text" size="small" class="yl-input_noIcon" placeholder="请输入数值" v-model="form.value" ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editCanel" class="yl-button2" size="mini">取 消</el-button>
            <el-button type="primary" class="yl-button" size="mini" @click="editData()">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import DataService from '@/api/data'
export default {
    data(){
        return{
            alias:'',
            factory_no:'',
            unitOrDescription:'',
            oldValue:'',
            dialogEditData:false,
            is_update_data:'',
            alarmsRealtimeData:[],
            serial_number:'',
            equipmentModel:'',
            stable:'',
            form:{
                value:''
            },
            variableName:'',//修改的变量名称
            editRules:{
                value:[{ required: true,message: '请输入数值', trigger: 'blur' }]
            },
            Interval:'',
            timer:''
        }
    },
    methods:{
        //获取定时器时间
        getTimer(type){
            let _this = this;
            DataService.queryTimer({
                user_id:this.$store.state.user_id
            }).then(res=>{
                this.Interval = Number(res.data)*1000
                 if(type == 'update'){
                    clearInterval(this.timer)
                    this.timer = setInterval(function(){
                        _this.getAlarmsRealtimeData();
                    }, this.Interval);
                }
            }).catch(err=>{
                this.$message.error(err.message)
            })
        },
        getAlarmsRealtimeData(){
            DataService.queryAlarmsRealtimeData({
                serialNumber:this.serial_number,
                equipmentModel:this.stable
            }).then(res=>{
                this.alarmsRealtimeData = res.data;
            }).catch(err=>{
                this.$message.error(err.message)
            })
        },
        edit(val){
            this.dialogEditData = true;
            this.form.value = val.data;
            this.variableName = val.name;
            this.alias = val.alias;
            this.unitOrDescription = val.unitOrDescription;
            this.oldValue = val.data;
        },
        //取消修改
        editCanel(){
            this.dialogEditData = false;
            this.$refs.edit.resetFields();
        },
        //修改实时数据数值
        editData(){
            let _this = this;
            this.$refs.edit.validate((valid)=>{
                if(valid){
                    DataService.updateVariableValues({
                        serialNumber:this.serial_number,
                        user_id:this.$store.state.user_id,
                        variableName:this.variableName,
                        value:this.form.value,
                        equipmentModel:this.stable,
                        username:this.$store.state.username,
                        id:this.id,
                        factory_no:this.factory_no,
                        alias:this.alias,
                        company:this.unitOrDescription,
                        oldValue:this.oldValue
                    }).then(res=>{
                        this.dialogEditData = false;
                        this.$message.success('修改成功');
                        setTimeout(() => {
                            _this.getAlarmsRealtimeData()
                        }, 3000);
                    }).catch(err=>{
                        this.$message.error(err.message)
                    })
                }else{
                    this.$message.error("请检查必填项");
                    return false;
                }
            })
        },
    },
    created(){
        this.getTimer()
        this.is_update_data = sessionStorage.getItem('is_update_data')
        if(this.$route.query.serial_number){
            this.serial_number = this.$route.query.serial_number;
            this.equipmentModel = this.$route.query.equipmentModel;
            this.stable = this.$route.query.stable;
            this.id = this.$route.query.id;
            this.factory_no = this.$route.query.geteway_name;
        }
    },
    mounted(){
        let _this = this;
        this.getAlarmsRealtimeData()
        setTimeout(()=>{
            this.timer = setInterval(()=>{
                _this.getAlarmsRealtimeData()
            },this.Interval)
        },1000)
    },
    beforeDestroy(){
        clearInterval(this.timer)
    }
}
</script>

<style lang="scss" scoped>
.main{
    padding:20px 0;
    .info{
        color: #fff;
        font-size: 16px;
        /deep/ .el-col{
            margin: 4px 0;
        }
        /deep/ .item{
            border: solid 1px #00C0FF;
            line-height: 40px;
            padding-left: 10px;
        }
        /deep/ .item:nth-child(2n){
            text-align: center;
            margin-left: none;
            padding-left: none!important;;
        }
    }
    .edit{
        cursor: pointer;
        color: #0ab3f0;
        margin-left: 10px;
    }
}
</style>